import { CrudQueryParams } from '~/api/def/endpoints/types';

export const crudParametersGenerator = <FIELDS extends string>(
  fields: Partial<CrudQueryParams<FIELDS>>,
) => {
  const queryParts: string[] = Object.keys(fields).map((key) => {
    return `${key}=${fields[key as FIELDS]}`;
  });
  return queryParts.join('&');
};
